import { css } from '@emotion/react';

export const systemNoticeGroup = css`
  display: flex;
  padding: 8px;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const lableSystemNotice = css`
  background-color: #c42915;
  border-radius: 28px;
  padding: 4px 17px;
  display: flex;
  justify-content: center;
  font-size: 12px;
  color: white;
  margin-right: 8px;
  word-break: break-word;
`;

export const contentSystemNotice = css`
  color: #c42915;
  font-size: 12px;
  white-space: break-spaces;
  word-break: break-word;
`;

export const lstSystemNotice = css`
  top: 0;
  cursor: pointer;
  background-color: #ffeeeb;
`;

export const contentModalSystemNotice = css`
  font-size: 16px;
  white-space: break-spaces;
  word-break: break-word;
`;
